import createElement from '@javascripts/utils/create_element';

export default class SeasonPanel {
  constructor({ data, episodePanel } = {}) {
    this._data = data;
    this._episodePanel = episodePanel;
  }

  data() {
    return this._data;
  }

  episodePanel() {
    return this._episodePanel;
  }

  dom() {
    this._container = this.createContainer();
    this._container.appendChild(this.createSeasonList());

    return this._container;
  }

  createContainer() {
    return createElement(`
      <div class="episode-chooser-season">
        <b class="episode-chooser-heading">Select Season</b>
      </div>
    `);
  }

  createListItem() {
    return createElement(`<li class="episode-chooser-season-list-item"></li>`);
  }

  createAnchor(season) {
    const anchor = createElement(`<a href="#">${season.name}</a>`);
    anchor.onclick = (e) => {
      e.preventDefault();
      this.episodePanel().showEpisodeFromSeason(season);
    };

    if (season.id == this.data().seasonId()) {
      anchor.classList.add('active');
      anchor.appendChild(this.checklist());
    }

    return anchor;
  }

  createSeasonList() {
    const container = createElement(`<ul class="episode-chooser-season-list"></ul>`);

    this.data().seasonsList().forEach((season) => {
      const list_item = this.createListItem();
      const anchor = this.createAnchor(season);

      list_item.appendChild(anchor);
      container.appendChild(list_item);
    });

    return container;
  }

  checklist() {
    return createElement(`
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><defs><filter id="a" width="105.9%" height="107.5%" x="-3%" y="-3.7%" filterUnits="objectBoundingBox"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/><feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0.117647059 0 0 0 0 0.117647059 0 0 0 0 0.117647059 0 0 0 0.1 0"/><feMerge><feMergeNode in="shadowMatrixOuter1"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs><g filter="url(#a)" transform="translate(-350 -108)" fill="none" fill-rule="evenodd"><path d="M350 108h24v24h-24z"/><path stroke="#00DE51" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M356 120.155l3.895 3.845 8.105-8"/></g></svg>
    `);
  }
}
